export default __webpack_public_path__ + "static/media/delete.280f3562.svg";